module.exports = __webpack_public_path__ + "media/ad_preview/yahoo-a16c40d3.png";